<template>
  <div v-if="!mobile" class="register">
    <span class="ball ball-1"></span>
    <span class="ball ball-2"></span>
    <span class="ball ball-3"></span>
    <span class="ball ball-4"></span>
    <span class="ball ball-5"></span>
    <ul>
      <li><span class="ball"></span></li>
      <li><span class="ball"></span></li>
      <li><span class="ball"></span></li>
      <li><span class="ball"></span></li>
    </ul>
    <div class="register-body flex">
      <div class="register-bg bd flex-center column">
        <div class="register-slogan">
          <div>AIOT</div>
          <div class="text-nowrap text-bold">全新一代物联网内核引擎</div>
        </div>
        <div class="bottom-line"></div>
      </div>
      <el-form ref="registerForm" v-loading="loading" :model="registerForm" :rules="registerRules" class="register-form ft" auto-complete="off" size="big" status-icon label-position="left">
        <div class="title">{{ '欢迎注册' }}</div>
        <el-form-item prop="username">
          <el-popover placement="right-start" width="285" trigger="click">
            <li>4-50个字符，可以使用英文字母、数字和特殊字符</li>
            <li>请勿包含身份证银行卡等隐私信息，一旦设置成功无法修改</li>
            <el-input slot="reference" v-model="registerForm.username" placeholder="请设置用户名称" prefix-icon="el-icon-user" clearable type="text" @input="checkUsername">
            </el-input>
          </el-popover>
        </el-form-item>
        <el-form-item prop="pw">
          <el-popover placement="right-start" width="285" trigger="click">
            <li>6-20个字符，密码不能和用户名称相同</li>
            <li>只能包含字母、数字以及标点符号（除空格）</li>
            <el-input slot="reference" v-model="registerForm.pw" placeholder="请设置登录密码" prefix-icon="el-icon-lock" clearable>
            </el-input>
          </el-popover>
        </el-form-item>
        <el-form-item prop="company">
          <el-input v-model="registerForm.company" placeholder="请输入公司名称" prefix-icon="el-icon-office-building" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input v-model="registerForm.mobile" placeholder="请输入手机号码" prefix-icon="el-icon-mobile-phone" clearable @input="checkMobile">
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <mobile-code v-model="registerForm.code" :mobile="registerForm.mobile" :verifyWay.sync="registerForm.verify_way" :validate-mobile-msg="mobileMsg" size="big"></mobile-code>
        </el-form-item>
        <el-form-item prop="" label="">
          <el-button class="submit" type="primary" :loading="postLoading" @click="submitRegist()">注册</el-button>
        </el-form-item>
        <div class="flex justify-content-center">
          <span class="text-muted">
            <span>已有账号？</span>
            <el-button class="relogin-btn" type="text" @click="handleRelogin">立即登录</el-button>
          </span>
        </div>
      </el-form>
    </div>
  </div>
  <SuggestToPC v-else />
</template>

<script>
import { validateRamUsername, validateMobile } from '@/utils/validate'
import { usernameCheckApi, registerApi, mobileCheckApi } from '@/api/common/registerApi'

export default {
  name: 'Register',

  data () {
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户名称不能为空'))
      } else {
        if (this.usernameMsg) callback(new Error(this.usernameMsg))
        if (validateRamUsername(value)) {
          callback()
        } else {
          return callback(new Error('用户名称只能由英文字母/数字/特殊字符组成'))
        }
      }
    }

    var validatePass = (rule, value, callback) => {
      if (value === this.registerForm.username) callback(new Error('请勿将用户名称设为密码'))
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (validateRamUsername(value)) {
          callback()
        } else {
          return callback(new Error('密码格式不正确！'))
        }
      }
    }

    var validateMobileNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入11位手机号码'))
      } else {
        if (this.mobileMsg) {
          return callback(new Error(this.mobileMsg))
        }
        if (validateMobile(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号码！'))
        }
      }
    }

    return {
      times: 0,
      sending: false,

      counter: 0,
      interval: 60,

      btnLoading: false,
      loading: false,
      postLoading: false,

      usernameMsg: '',
      registerForm: {
        username: '',
        pw: '',
        mobile: '',
        code: null,
        company: '',
        verify_way: 1
      },
      registerRules: {
        username: [
          { min: 4, max: 50, message: '名称长度应在 4 到 50 个字符', trigger: 'blur' },
          { validator: validateUsername, trigger: 'blur' }
        ],
        pw: [
          { min: 6, max: 20, message: '密码长度不正确', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        mobile: [
          { min: 11, max: 11, message: '手机号码长度不正确', trigger: 'blur' },
          { validator: validateMobileNumber, trigger: 'blur' }
        ],
        code: [
          { min: 4, max: 4, message: '请填写正确的验证码', trigger: 'blur' },
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },

      mq: null,
      mobile: false,
      mobileMsg: ''
    }
  },

  components: {
    SuggestToPC: () => import("@/views/common/components/SuggestToPC.vue"),
    MobileCode: () => import("@/views/common/components/MobileCode.vue")
  },

  created () {
  },

  mounted () {
    this.mq = window.matchMedia('(max-width: 900px)')
    this.mq.addEventListener('change', this.checkDeviceType)
    this.checkDeviceType(this.mq)
  },

  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }

    if (this.mq) {
      this.mq.removeEventListener('change', this.checkDeviceType)
    }
  },

  methods: {
    handleRelogin () {
      this.$router.replace('/login')
    },

    checkUsername () {
      usernameCheckApi({ username: this.registerForm.username }).then((res) => {
        if (res.errno) {
          this.usernameMsg = res.message
        } else {
          this.usernameMsg = ''
        }
      })
    },

    checkMobile () {
      mobileCheckApi({ mobile: this.registerForm.mobile }).then((res) => {
        if (res.errno) {
          this.mobileMsg = res.message
        } else {
          this.mobileMsg = ''
        }
      })
    },

    submitRegist () {
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          this.postLoading = true
          registerApi(this.registerForm).then((res) => {
            if (!res.errno) { // 注册成功后直接进行登录api调用并跳转至快速入门
              this.postLoading = false
              const loginForm = {
                username: this.registerForm.username,
                password: this.registerForm.pw
              }
              this.$store.dispatch('loginByUsernameAction', loginForm).then((res) => {
                if (!res.errno) {
                  this.$message.success(`欢迎登录，${loginForm.username}`)
                  this.$router.push({ path: '/guide' })
                }
              })
            } else {
              this.postLoading = false
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    checkDeviceType(e) {
      if (e.matches && /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        this.mobile = true
      } else {
        this.mobile = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.register {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background-color: #f9fffc;
  background-size: 100% auto;

  .ball {
    position: absolute;
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: linear-gradient(0deg, #8bd09a 19%, #f2f9f7 90%);
    background-size: 100% auto;
  }
  .ball.ball-1 {
    top: 40px;
    left: 50%;
    width: 120px;
    height: 120px;
    transform: translateX(-50%) rotate(-180deg);
  }
  .ball.ball-2 {
    // display: none;
    top: -120px;
    left: -50px;
    transform: rotate(100deg);
    width: 320px;
    height: 320px;
  }
  .ball.ball-3 {
    display: none;
    top: 120px;
    right: 15%;
    width: 120px;
    height: 120px;
    transform: rotate(-90deg);
  }
  .ball.ball-4 {
    top: 35%;
    right: 60px;
    width: 120px;
    height: 120px;
    transform: rotate(270deg);
  }
  .ball.ball-5 {
    top: 35%;
    left: 60px;
    width: 40px;
    height: 40px;
    transform: rotate(270deg);
    background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    opacity: 1;
  }
  .register-body {
    position: absolute;
    display: flex;
    z-index: 999;
    height: 520px;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    background-color: transparent;
    border-radius: 5px;
    .register-bg {
      height: 100%;
      position: relative;
      font-size: 48px;
      padding-right: 150px;
      .bottom-line{
        z-index: -1;
        margin-top: -15px;
        width: 100%;
        height: 25px;
        background: linear-gradient(87.21deg, rgba(40,167,69,0) 10.49%,rgba(40,167,69,0.8) 100.88%);
      }
    }
    .register-form {
      text-align: center;
      box-sizing: border-box;
      padding: 30px 35px;
      width: 400px;
      background-color: #fff;
      box-shadow: -2px 8px 50px 0px rgba(238, 240, 240, 1);
      border-radius: 10px;
      .title {
        font-size: 28px;
        font-weight: bold;
        letter-spacing: 5px;
        color: #000;
        margin-bottom: 22px;
      }
      .el-input {
        .el-input__inner {
          background: transparent;
          color: #fff;
          font-size: 16px;
        }
        .el-input__prefix {
          font-size: 18px;
        }
      }
      .submit {
        width: 100%;
        border-radius: 30px;
        letter-spacing: 5px;
        font-size: 16px;
      }
      .register-btn {
        color: #666;
      }
      .relogin-btn {
        color: #07c160;
        margin-top: -22px;
      }
    }
  }

  ul {
    width: 80vw;
    height: 80vw;
    margin: 40px auto;
    position: relative;
    list-style: none;
  }
  ul li {
    border: 2px solid #ceedd79f;
    position: absolute;
    left: 50%;
    top: 60%;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: orbit;
  }
  ul li .ball {
    display: block;
    position: absolute;
    left: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-size: 100% auto;
  }
  ul li:nth-child(1) {
    width: 30%;
    height: 30%;
    animation-duration: 14s;
  }
  ul li:nth-child(1) .ball {
    left: 20%;
    top: 2%;
    width: 40px;
    height: 40px;
  }
  ul li:nth-child(2) {
    width: 50%;
    height: 50%;
    animation-duration: 16s;
  }
  ul li:nth-child(2) .ball {
    left: 75%;
    top: 5%;
    width: 60px;
    height: 60px;
  }
  ul li:nth-child(3) {
    width: 60%;
    height: 60%;
    animation-duration: 28s;
  }
  ul li:nth-child(3) .ball {
    width: 80px;
    height: 80px;
    left: 10%;
    top: 10%;
    background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    opacity: 1;
  }
  ul li:nth-child(4) {
    width: 100%;
    height: 100%;
    animation-duration: 45s;
    margin-top: 8%;
  }
  ul li:nth-child(4) > .ball {
    width: 100px;
    height: 100px;
    left: 11.3%;
    top: 11.3%;
    background: radial-gradient(circle at 22%, #f9fffc 0%, #37d17d);
    opacity: 1;
    transform: rotate(120deg);
  }

  @keyframes orbit {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
}
</style>
